// Fee & Obligation PR-5 — read hooks for the standing worksheet's forward
// projection and the Income Pools forward overlay. Read-only: no mutations, so
// no invalidation (the projection is derived live from the ledger / obligation
// reads; a fee/obligation mutation invalidates those loan keys elsewhere).

import { useQuery } from "@tanstack/react-query";
import { forwardProjectionApi } from "@/api/portfolioAdmin/forwardProjectionApi";
import { forwardProjectionKeys } from "./forwardProjectionKeys";

const DEFAULT_HORIZON = 12;

export function useForwardProjection(
  loanId: string | undefined,
  horizonMonths: number = DEFAULT_HORIZON,
) {
  return useQuery({
    queryKey: forwardProjectionKeys.projection(loanId ?? "", horizonMonths),
    queryFn: () => forwardProjectionApi.get(loanId!, horizonMonths),
    enabled: !!loanId,
  });
}

export function useIncomePoolsForward(
  loanId: string | undefined,
  horizonMonths: number = DEFAULT_HORIZON,
) {
  return useQuery({
    queryKey: forwardProjectionKeys.incomePoolsForward(loanId ?? "", horizonMonths),
    queryFn: () => forwardProjectionApi.incomePoolsForward(loanId!, horizonMonths),
    enabled: !!loanId,
  });
}
